module.exports = __webpack_public_path__ + "img/mobile_activity_feed_preview@2x.e5fe78a5.png";